<template>
    <v-dialog v-model="addnotedialog" max-width="400">
        <template v-slot:activator="{ on }">
            <v-btn small v-on="on" rounded outlined>
                <v-icon>{{icons.plus}}</v-icon>
            </v-btn>
        </template>
        <v-card>
            <v-card-title><v-icon></v-icon>Add Note</v-card-title>
            <v-card-text>
                <v-flex row wrap>
                    <v-flex xs12>
                        <v-textarea
                                label="Outline"
                                placeholder="Placeholder"
                                outlined
                                v-model="notetext"
                        ></v-textarea>
                    </v-flex>
                </v-flex>
            </v-card-text>
            <v-card-actions>
                <v-btn text @click="addnotedialog=false">cancel</v-btn>
                <v-spacer></v-spacer>
                <v-btn text @click="saveNote()" :loading="loading" >save</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
  import {
    mapState,
    mapActions
  } from 'vuex'
  export default {
    components: {},
    props: ['tag', 'orgkey'],
    name: "AddNote",
    data() {
      return {
        addnotedialog: false,
        notetext: '',
        loading: false
      }
    },
    mounted() {
    },
    computed: {
      ...mapState(['icons','cognito'])
    },
    methods: {
      ...mapActions(['put']),
      saveNote() {
        this.loading=true;
        let data = {
          type: 'text',
          tag: [this.tag],
          orgkey: this.orgkey,
          body: this.notetext,
          email: this.cognito.user.attributes.email
        }
        let res = this.put({path:'api/notes/savenote', body:data})
        this.addnotedialog=false;
        this.notetext='';
        this.$emit('close',true)
      },
    }
  }
</script>

<style scoped>

</style>